import { Star } from "lucide-react";

const reviews = [
  {
    quote: "Exceptional food, warm hospitality and unforgettable game drives.",
    source: "TripAdvisor",
    rating: 5,
  },
  {
    quote: "A tranquil, malaria-free escape — every detail thoughtfully done.",
    source: "Booking.com",
    rating: 5,
  },
  {
    quote: "Personal, refined and genuinely African. We will be back.",
    source: "Google Reviews",
    rating: 5,
  },
];

const HomeReviewsStrip = () => {
  return (
    <section
      aria-label="Guest reviews"
      className="bg-background border-y border-border/60 py-8 sm:py-10"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="eyebrow text-center !text-gold mb-6">Loved by our guests</p>
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((r) => (
            <li key={r.source} className="text-center px-2">
              <div
                className="flex justify-center gap-0.5 mb-3 text-gold"
                aria-label={`${r.rating} out of 5 stars`}
              >
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star key={i} size={14} fill="currentColor" strokeWidth={0} aria-hidden="true" />
                ))}
              </div>
              <blockquote className="font-heading italic text-sm sm:text-base text-foreground leading-relaxed">
                “{r.quote}”
              </blockquote>
              <p className="mt-3 text-[11px] tracking-[0.2em] uppercase text-muted-foreground">
                {r.source}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HomeReviewsStrip;
